import { fromShortToLong } from '@/lang/languageCodes';

const getBackRoute = (state) => {
  if (!state.backRoute) {
    return '/classes';
  }
  return state.backRoute;
};
const getLastClassesPath = state => state.lastClassesPath;
const getUserSettings = state => state.userSettings;
const getAppleDetails = state => state.appleDetails;
const getLearnedLanguage = state => state.learnedLanguage;
const getIsLearnedLanguageEsp = state =>
  (state.learnedLanguage ? state.learnedLanguage.includes('esp') : false);
const getSiteLanguage = (state) => {
  if (state.siteLanguage === undefined) {
    return fromShortToLong[navigator.language.substring(0, 2)];
  }
  return state.siteLanguage;
};
const getWindowWidth = state => state.windowWidth;
const getUserIsLoggedIn = state => state.userIsLoggedIn;
const getSessionExpired = state => state.sessionExpired;

// const getDktDeeplinkParams = state => state.dktDeeplinkParams;

const getDktDeeplinkParams = (state) => {
  const defaultState = {
    assignmentId: undefined,
    dktAssignmentId: undefined,
    idpToken: undefined
  };

  let dktDeeplinkParams = window.sessionStorage.getItem('dktDeeplinkParams');
  let returnObject = defaultState;
  if (dktDeeplinkParams) {
    dktDeeplinkParams = JSON.parse(dktDeeplinkParams);
    returnObject = { ...defaultState, ...dktDeeplinkParams };
  }
  return returnObject;
};

const getHandledUnauthorizedError = state => state.handledUnauthorizedError;
const getGuestLink = state => state.guestLink;
const getGuestError = state => state.guestError;
const getAppBannerVisible = state => state.appBannerVisible;
const getNarratorLanguage = (state) => {
  if (state.narratorLanguage === undefined) {
    return navigator.language.substring(0, 2);
  }
  return state.narratorLanguage;
};
const getWCAGSettings = state => state.wcag;

export default {
  getBackRoute,
  getLastClassesPath,
  getUserSettings,
  getAppleDetails,
  getLearnedLanguage,
  getIsLearnedLanguageEsp,
  getSiteLanguage,
  getWindowWidth,
  getUserIsLoggedIn,
  getSessionExpired,
  getDktDeeplinkParams,
  getHandledUnauthorizedError,
  getGuestLink,
  getGuestError,
  getAppBannerVisible,
  getNarratorLanguage,
  getWCAGSettings
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/getters.js